import { ru } from 'date-fns/locale';

const locales = { ru };

const getDateFnsLocale = (locale) => {
  return locales[locale];
};

export default getDateFnsLocale;
